import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { Button } from 'reactstrap';
import { useUserContext } from '../../shared/user-context';

const Logout: React.FC<{ auto?: boolean }> = (props) => {
    const navigate = useNavigate();
    const userContext = useUserContext();
   
    const doLogout = useCallback(() => {
        userContext.logOut();
        navigate("/login");
    }, [navigate, userContext])

    React.useEffect(() => {
        if (props.auto) {
            doLogout();
        }
    });

    const signOut = (e: React.MouseEvent) => {
        e.preventDefault();
        doLogout();
    }

    return (
        <Button color="primary" onClick={signOut}>log out</Button>
    );
}

export default Logout;